import React from 'react'
import PropTypes from 'prop-types'
import { FormInput, Margin, Text } from 'shared/components'
import { EditableFormPanel } from 'routes/shared/components'
import { dateWithTime } from 'constants/dateFormats'

import * as styles from './styles'
import { getOptionLabel, getOptionValue } from './helpers'

const EditTournamentFormComponent = ({
  header,
  loadCategories,
  loadJurisdictions,
  form,
  onSubmitRequest,
}) => {
  return (
    <EditableFormPanel header={header} form={form} onSubmit={onSubmitRequest}>
      {(editable) => (
        <>
          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Sport
            </Text>
            <FormInput
              oldInput
              type="async-select"
              name="sportType"
              placeholder="Sport"
              cacheOptions
              defaultOptions
              isSearchable={false}
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              loadOptions={loadCategories}
              styles={styles.select}
              css={styles.dropdownControl}
              disabled={!editable}
              bordered
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Name
            </Text>
            <FormInput
              type="text"
              name="tournamentName"
              placeholder="Tournament Name"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Full Name
            </Text>
            <FormInput
              type="text"
              name="tournamentFullName"
              placeholder="Tournament Full Name"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Logo
            </Text>
            <FormInput
              type="text"
              name="logo"
              placeholder="Logo"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Large Logo
            </Text>
            <FormInput
              type="text"
              name="largeLogo"
              placeholder="Large logo"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Jurisdiction
            </Text>
            <FormInput
              oldInput
              type="async-select"
              name="jurisdiction"
              placeholder="Jurisdiction"
              cacheOptions
              defaultOptions
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              loadOptions={loadJurisdictions}
              styles={styles.select}
              css={styles.dropdownControl}
              disabled={!editable}
              bordered
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Country
            </Text>
            <FormInput
              oldInput
              cacheOptions
              defaultOptions
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              type="async-select"
              name="country"
              placeholder="Select country"
              loadOptions={loadJurisdictions}
              disabled={!editable}
              styles={styles.select}
              css={styles.dropdownControl}
              bordered
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              City
            </Text>
            <FormInput
              name="city"
              placeholder="City"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Venue
            </Text>
            <FormInput
              type="text"
              name="venue"
              placeholder="Venue"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Start date
            </Text>
            <FormInput
              name="startTime"
              type="date"
              placeholder="MM/dd/yyyy"
              styles={styles.select}
              css={styles.dropdownControl}
              disabled={!editable}
              options={{
                showTimeInput: false,
                showYearDropdown: true,
                dateFormat: 'MM/dd/yyyy',
                placeholderText: 'MM/dd/yyyy',
              }}
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Start time
            </Text>
            <FormInput
              name="startTimeHour"
              type="time"
              placeholder="HH:mm"
              styles={styles.select}
              css={styles.dropdownControl}
              disabled={!editable}
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              End date
            </Text>
            <FormInput
              name="endTime"
              type="date"
              placeholder="MM/dd/yyyy"
              styles={styles.select}
              css={styles.dropdownControl}
              disabled={!editable}
              options={{
                showTimeInput: false,
                showYearDropdown: true,
                dateFormat: 'MM/dd/yyyy',
                placeholderText: 'MM/dd/yyyy',
              }}
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              End time
            </Text>
            <FormInput
              name="endTimeHour"
              type="time"
              placeholder="HH:mm"
              styles={styles.select}
              css={styles.dropdownControl}
              disabled={!editable}
            />
          </Margin>

          <Margin bottom={1} css={styles.row}>
            <Text as="label" size={11}>
              Website
            </Text>
            <FormInput
              type="text"
              name="website"
              placeholder="Website"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>

          <Margin bottom={1} css={styles.rowWithToggle}>
            <Text as="label" size={11}>
              Marketing Promotion
            </Text>
            <FormInput
              oldInput
              name="marketingPromotion"
              type="toggle"
              css={styles.control}
              disabled={!editable}
            />
          </Margin>

          <FormInput name="followed" type="hidden" />
          <FormInput name="id" type="hidden" />
        </>
      )}
    </EditableFormPanel>
  )
}

EditTournamentFormComponent.propTypes = {
  form: PropTypes.shape({
    value: PropTypes.object,
    touched: PropTypes.object,
    errors: PropTypes.object,
    setFieldValue: PropTypes.func,
  }).isRequired,
  header: PropTypes.string.isRequired,
  loadCategories: PropTypes.func.isRequired,
  loadJurisdictions: PropTypes.func.isRequired,
  onSubmitRequest: PropTypes.func.isRequired,
}

export default EditTournamentFormComponent
